import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';
import { LanguageToggle } from './ui/LanguageToggle';
import { useLang } from '../lib/i18n/LanguageContext';
import { dictionary } from '../lib/i18n/dictionary';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const {
    lang
  } = useLang();
  const t = dictionary.nav;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  const isHome = location.pathname === '/';
  // On home page, link to anchors. Off home, link to /#anchor.
  const anchor = (id: string) => isHome ? `#${id}` : `/#${id}`;
  const items = [{
    label: t.solution[lang],
    to: anchor('solution')
  }, {
    label: t.how[lang],
    to: anchor('how')
  }, {
    label: t.network[lang],
    to: '/suppliers'
  }, {
    label: t.about[lang],
    to: '/about'
  }, {
    label: t.faq[lang],
    to: '/faq'
  }, {
    label: t.contact[lang],
    to: '/contact'
  }];
  const linkCls = 'text-sm text-slate-300 hover:text-white transition-colors';
  const activeCls = 'text-white';
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled || !isHome ? 'bg-navy-deep/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`} data-id="element-171">
      <nav className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between" aria-label="Primary" data-id="element-172">
        <Link to="/" className="flex items-center gap-2.5 group" data-id="element-173">
          <span className="relative inline-flex items-center justify-center w-8 h-8 border border-gold/50 rounded-sm" data-id="element-174">
            <span className="absolute inset-1 bg-gold/15" data-id="element-175" />
            <span className="relative font-serif text-gold text-sm" data-id="element-176">A</span>
          </span>
          <span className="text-white text-[15px] font-medium tracking-tight hidden sm:inline" data-id="element-177">
            America's Energy Bridge
          </span>
        </Link>

        <ul className="hidden lg:flex items-center gap-7" data-id="element-178">
          {items.map(it => {
          const isExternalAnchor = it.to.startsWith('#') || it.to.startsWith('/#');
          return <li key={it.label} data-id="element-179">
                {isExternalAnchor ? <a href={it.to} className={linkCls} data-id="element-180">
                    {it.label}
                  </a> : <NavLink to={it.to} end={it.to === '/'} className={({
              isActive
            }) => `${linkCls} ${isActive ? activeCls : ''}`} data-id="element-181">
                    {it.label}
                  </NavLink>}
              </li>;
        })}
        </ul>

        <div className="hidden lg:flex items-center gap-3" data-id="element-182">
          <LanguageToggle data-id="element-183" />
          <Link to="/contact" data-id="element-184">
            <Button variant="gold" size="sm" data-id="element-185">
              {t.requestAccess[lang]}
            </Button>
          </Link>
        </div>

        {/* Mobile: always-visible language toggle + menu button */}
        <div className="flex lg:hidden items-center gap-2" data-id="element-186">
          <LanguageToggle data-id="element-187" />
          <button className="text-white p-2" onClick={() => setOpen(v => !v)} aria-label="Toggle menu" aria-expanded={open} data-id="element-188">
            {open ? <XIcon className="w-5 h-5" data-id="element-189" /> : <MenuIcon className="w-5 h-5" data-id="element-190" />}
          </button>
        </div>
      </nav>

      {open && <div className="lg:hidden bg-navy-deep border-t border-white/10" data-id="element-191">
          <ul className="px-5 py-4 space-y-1.5" data-id="element-192">
            {items.map(it => {
          const isExternalAnchor = it.to.startsWith('#') || it.to.startsWith('/#');
          return <li key={it.label} data-id="element-193">
                  {isExternalAnchor ? <a href={it.to} className="block text-slate-200 py-2 text-sm" data-id="element-194">
                      {it.label}
                    </a> : <Link to={it.to} className="block text-slate-200 py-2 text-sm" data-id="element-195">
                      {it.label}
                    </Link>}
                </li>;
        })}
            <li className="pt-3" data-id="element-196">
              <Link to="/contact" data-id="element-197">
                <Button variant="gold" size="sm" className="w-full" data-id="element-198">
                  {t.requestAccess[lang]}
                </Button>
              </Link>
            </li>
          </ul>
        </div>}
    </header>;
}